import { NBSP } from '../../../../constants/symbols';

export const formatCardNumber = (last4: string): string => {
  return `··${NBSP}${last4}`;
};
